// import React from "react";
// import HeaderOne from "./HeaderOne";
// import FooterOne from "./FooterOne";

// const MarketPlace = () => {
//   return (
//     <>
//     <HeaderOne/>
//     <div className="bg-white text-gray-800 min-h-screen py-16 px-6 md:px-20">
//       <div className="max-w-5xl mx-auto">
//         <h1 className="text-4xl font-bold mb-8 text-center">
//           Marketplace Declaration
//         </h1>

//         <p className="mb-6 text-lg">
//           Welcome to <strong>Morden Bazaar</strong>. This Marketplace
//           Declaration outlines the principles, responsibilities, and guidelines
//           governing the use of our online marketplace platform. By accessing or
//           using our services, you agree to comply with the terms stated below.
//         </p>

//         {/* Section 1 */}
//         <section className="mb-8">
//           <h2 className="text-2xl font-semibold mb-3">1. Definitions</h2>
//           <ul className="list-disc ml-6 space-y-2">
//             <li>
//               <strong>Marketplace:</strong> The platform operated by Morden
//               Bazaar enabling buying and selling of products.
//             </li>
//             <li>
//               <strong>User:</strong> Any individual or business registered on
//               the platform.
//             </li>
//             <li>
//               <strong>Buyer:</strong> A user who purchases products through the
//               marketplace.
//             </li>
//             <li>
//               <strong>Seller:</strong> A user who lists products for sale.
//             </li>
//             <li>
//               <strong>Transaction:</strong> A completed purchase facilitated
//               through the platform.
//             </li>
//           </ul>
//         </section>

//         {/* Section 2 */}
//         <section className="mb-8">
//           <h2 className="text-2xl font-semibold mb-3">
//             2. User Responsibilities
//           </h2>
//           <p className="mb-3">
//             All users must provide accurate and up-to-date information and must
//             have the legal capacity to enter into binding agreements.
//           </p>
//           <ul className="list-disc ml-6 space-y-2">
//             <li>Engage in lawful and ethical conduct.</li>
//             <li>Avoid fraudulent, deceptive, or illegal activities.</li>
//             <li>Respect the privacy and rights of other users.</li>
//           </ul>
//         </section>

//         {/* Section 3 */}
//         <section className="mb-8">
//           <h2 className="text-2xl font-semibold mb-3">
//             3. Buyer Guidelines
//           </h2>
//           <ul className="list-disc ml-6 space-y-2">
//             <li>Review product details carefully before purchase.</li>
//             <li>Complete payments in accordance with platform policies.</li>
//             <li>
//               Contact sellers first for transaction issues before escalating to
//               support.
//             </li>
//           </ul>
//         </section>

//         {/* Section 4 */}
//         <section className="mb-8">
//           <h2 className="text-2xl font-semibold mb-3">
//             4. Seller Guidelines
//           </h2>
//           <ul className="list-disc ml-6 space-y-2">
//             <li>Provide accurate and lawful product descriptions.</li>
//             <li>Fulfill orders in a timely manner.</li>
//             <li>Comply with applicable commerce and tax laws.</li>
//           </ul>
//         </section>

//         {/* Section 5 */}
//         <section className="mb-8">
//           <h2 className="text-2xl font-semibold mb-3">
//             5. Marketplace Policies
//           </h2>
//           <ul className="list-disc ml-6 space-y-2">
//             <li>Illegal or restricted items are strictly prohibited.</li>
//             <li>
//               Applicable service fees will be clearly disclosed before
//               transactions.
//             </li>
//             <li>
//               User data is handled according to our Privacy Policy and relevant
//               data protection laws.
//             </li>
//           </ul>
//         </section>

//         {/* Section 6 */}
//         <section className="mb-8">
//           <h2 className="text-2xl font-semibold mb-3">
//             6. Dispute Resolution
//           </h2>
//           <p>
//             Users are encouraged to resolve disputes directly. If unresolved,
//             Morden Bazaar may provide mediation support where appropriate.
//           </p>
//         </section>

//         {/* Section 7 */}
//         <section className="mb-8">
//           <h2 className="text-2xl font-semibold mb-3">
//             7. Changes to this Declaration
//           </h2>
//           <p>
//             Morden Bazaar reserves the right to modify this declaration at any
//             time. Continued use of the platform constitutes acceptance of the
//             updated terms.
//           </p>
//         </section>

//         {/* Section 8 */}
//         <section>
//           <h2 className="text-2xl font-semibold mb-3">
//             8. Contact Information
//           </h2>
//           <p>Email: support@mordenbazaar.com</p>
//           <p>
//             By using the Morden Bazaar marketplace, you acknowledge that you
//             have read and agreed to this Marketplace Declaration.
//           </p>
//         </section>
//       </div>
//     </div>
//     <FooterOne/>
//     </>
//   );
// };

// export default MarketPlace;

import React from "react";
import HeaderOne from "./HeaderOne";
import FooterOne from "./FooterOne";

const MarketplaceDeclaration = () => {
  return (
    <>
    <HeaderOne/>
    <div className="bg-white text-gray-800 min-h-screen py-16 px-6 md:px-20">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl font-bold mb-6 text-center">
          Marketplace Declaration
        </h1>

        <p className="mb-6 text-lg">
          This Marketplace Declaration (“Declaration”) governs the use of the
          online marketplace platform <strong>MordenBazaar</strong>, which is
          owned and operated by <strong>FZ Signature Tools Private Limited</strong>
          (hereinafter referred to as “Company”, “we”, “our”, or “us”).
          By accessing or using MordenBazaar, you agree to comply with and be
          bound by this Declaration and all applicable policies.
        </p>

        {/* Section 1 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">1. About the Marketplace</h2>
          <p>
            MordenBazaar is an online marketplace platform that facilitates
            transactions between independent sellers and buyers. The Company
            provides the technology infrastructure, payment facilitation, and
            support services necessary to enable such transactions.
          </p>
        </section>

        {/* Section 2 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">2. Role of the Company</h2>
          <p>
            FZ Signature Tools Private Limited operates MordenBazaar solely as
            an intermediary platform. The Company does not manufacture, own,
            stock, or directly sell the products listed by third-party sellers
            unless explicitly stated.
          </p>
          <ul className="list-disc ml-6 mt-3 space-y-2">
            <li>The Company is not responsible for product quality unless sold directly by it.</li>
            <li>The Company does not guarantee seller performance.</li>
            <li>All contracts of sale are strictly between Buyer and Seller.</li>
          </ul>
        </section>

        {/* Section 3 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">3. Seller Responsibilities</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li>Provide accurate and lawful product descriptions.</li>
            <li>Ensure authenticity and compliance with applicable laws.</li>
            <li>Fulfill orders promptly and handle returns/refunds responsibly.</li>
            <li>Comply with tax regulations and statutory obligations.</li>
          </ul>
        </section>

        {/* Section 4 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">4. Buyer Responsibilities</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li>Review product details carefully before purchase.</li>
            <li>Make payments through approved payment methods.</li>
            <li>Raise disputes within the specified timeline.</li>
            <li>Provide accurate delivery information.</li>
          </ul>
        </section>

        {/* Section 5 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">5. Prohibited Activities</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li>Listing illegal, counterfeit, or restricted items.</li>
            <li>Engaging in fraudulent or deceptive practices.</li>
            <li>Misusing platform data or violating intellectual property rights.</li>
          </ul>
        </section>

        {/* Section 6 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">6. Limitation of Liability</h2>
          <p>
            FZ Signature Tools Private Limited shall not be liable for any
            indirect, incidental, or consequential damages arising from the
            use of MordenBazaar. The Company’s role is limited to providing the
            platform infrastructure for transactions.
          </p>
        </section>

        {/* Section 7 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">7. Modifications</h2>
          <p>
            The Company reserves the right to modify this Declaration at any
            time. Continued use of MordenBazaar constitutes acceptance of the
            updated terms.
          </p>
        </section>

        {/* Section 8 */}
        <section>
          <h2 className="text-2xl font-semibold mb-3">8. Contact Information</h2>
          <p>
            For any queries regarding this Marketplace Declaration, please
            contact:
          </p>
          <p className="mt-2">
            <strong>FZ Signature Tools Private Limited</strong>
          </p>
          <p>Email: support@mordenbazaar.com</p>
        </section>

        <p className="mt-10 text-sm text-gray-500 text-center">
          Last Updated: {new Date().toLocaleDateString()}
        </p>
      </div>
    </div>
    <FooterOne/>
    </>
  );
};

export default MarketplaceDeclaration;

